import Vue from "vue"
import VueRouter from "vue-router"
import Home from '../views/Home'
import Search from '../views/Search'
import Place from '../views/Place'
import Missing from '../views/Missing'
import AddNewBusiness from '../views/AddNewBusiness'
import AddReview from '../views/AddReview'
import Photos from '../views/Photos'

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home
    },
    {
        path: "/search",
        name: "Search",
        component: Search
    },
    {
        path: "/place/:id",
        name: "Place",
        component: Place
    },
    {
        path: "*",
        component: Missing
    },
    {
        path: "/newbusiness",
        name: "AddNewBusiness",
        component: AddNewBusiness,
        beforeEnter: (to, from, next) => {
            if (Vue.prototype.$keycloak.authenticated) {
                next()
            } else {
                Vue.prototype.$keycloak.login()
            }
        }
    },
    {
        path: "/place/:id/addreview",
        name: "AddReview",
        component: AddReview,
        beforeEnter: (to, from, next) => {
            if (Vue.prototype.$keycloak.authenticated) {
                next()
            } else {
                Vue.prototype.$keycloak.login()
            }
        }
    },
    {
        path: "/place/:id/photos",
        name: "Photos",
        component: Photos
    }
]

const router = new VueRouter({
    mode: "history",
    base: "/",
    routes
})

export default router